<template>
  <r-panel :disabled="disabled" :title="title" :button_add="true" @click_add="click_add">
    <r-level-track-level-pattern-table ref="table" :items.sync="values" :toolbar="false"/>
  </r-panel>
</template>

<script>


import VueTypes from "vue-types";

import RLevelTrackLevelPatternTable from "@/modules/redactor/views/level-track/level/pattern/r-level-track-level-pattern-table.vue";
import RPanel from "@/modules/redactor/views/utils/r-panel.vue";

import { LevelTrackLevelPattern } from "@/modules/redactor/models/level-track/LevelTrackLevelPattern";

export default {
  name: "r-level-track-level-pattern-panel",
  components: {RPanel, RLevelTrackLevelPatternTable},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Pattern"),
    items: VueTypes.arrayOf(LevelTrackLevelPattern),
  },
  computed: {
    values() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>
